import { useTranslation } from "react-i18next";
import React from "react";
import { TripleSpinner } from "../../ui/TripleSpinner";
import { Button, Col, Row } from "react-bootstrap";

interface IAccountSetupStep1 {
  onNext: () => void;
}

const AccountSetupStep1 = ({ onNext }: IAccountSetupStep1) => {
  const { t, ready } = useTranslation();

  if (!ready) {
    return <TripleSpinner />;
  }

  return (
    <>
      <Row>
        <Col className="header">{t("accountSetup.step1.header")}</Col>
      </Row>
      <Row>
        <Col className="subheader">{t("accountSetup.step1.intro")}</Col>
      </Row>
      <Row className="mt-4 mb-2">
        <Col xs={12} className="d-flex align-items-start mb-3" style={{ gap: 14 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              minWidth: 32,
              borderRadius: "50%",
              background: "#f5e9c9",
              color: "#8e6627",
              fontWeight: 700,
              fontSize: 15,
            }}
          >
            1
          </span>
          <span style={{ color: "#525252", fontSize: 15, lineHeight: 1.6, paddingTop: 4 }}>
            {t("accountSetup.step1.stepOne")}
          </span>
        </Col>
        <Col xs={12} className="d-flex align-items-start mb-3" style={{ gap: 14 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              minWidth: 32,
              borderRadius: "50%",
              background: "#f5e9c9",
              color: "#8e6627",
              fontWeight: 700,
              fontSize: 15,
            }}
          >
            2
          </span>
          <span style={{ color: "#525252", fontSize: 15, lineHeight: 1.6, paddingTop: 4 }}>
            {t("accountSetup.step1.stepTwo")}
          </span>
        </Col>
      </Row>
      <Row className="mt-2 mb-4">
        <Col className="text-center">
          <span
            style={{
              display: "inline-block",
              padding: "8px 20px",
              borderRadius: 999,
              background: "#eaf5ef",
              color: "#1f7a4d",
              fontSize: 14,
              fontWeight: 600,
              letterSpacing: "-0.01em",
            }}
          >
            {t("accountSetup.step1.noHardChecks")}
          </span>
        </Col>
      </Row>
      <Row>
        <Col lg={2} />
        <Col className="buttons">
          <Button id="step1-submit" onClick={onNext}>
            {t("accountSetup.next")}
          </Button>
        </Col>
        <Col lg={2} />
      </Row>
    </>
  );
};

export default AccountSetupStep1;
